import React, { useEffect, useRef, useState } from 'react';
import '../App.css';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import logo from '../assets/simboloVitaResize.png';
import empresa1 from '../assets/clients/empresa1.png';
import empresa2 from '../assets/clients/empresa2.png';
import empresa3 from '../assets/clients/empresa3.jpg';
import empresa4 from '../assets/clients/empresa4.jpg';
import empresa5 from '../assets/clients/empresa5.jpg';
import empresa6 from '../assets/clients/empresa6.png';
import empresa7 from '../assets/clients/empresa7.jpg';
import empresa8 from '../assets/clients/empresa8.png';
import empresa9 from '../assets/clients/empresa9.jpg';
import empresa10 from '../assets/clients/empresa10.jpg';
import empresa11 from '../assets/clients/empresa11.jpg';
import empresa12 from '../assets/clients/empresa12.png';
import empresa13 from '../assets/clients/empresa13.png';
import Button from '@mui/material/Button';
import HamburgerComponent from './layout/HamburgerComponent';
import {
  CalendarMonth,
  CardGiftcard,
  CheckCircleOutline,
  CloudCircleOutlined,
  ComputerOutlined,
  SmartphoneOutlined,
} from '@mui/icons-material';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Element, Link, scroller } from 'react-scroll';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Drawer, MenuItem, Select } from '@mui/material';
import { useDispatch } from 'react-redux';
import { newCustomerActions } from '../store/newCustomer';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 7,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 1300 },
    items: 5,
  },
  mediumDesktop: {
    breakpoint: { max: 1300, min: 1074 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1074, min: 860 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 860, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const responsiveTestimonials = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 1300 },
    items: 2,
  },
  mediumDesktop: {
    breakpoint: { max: 1300, min: 1074 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 1074, min: 860 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 860, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const textArray = ['o crescimento', 'a vitalidade', 'a organização'];

const PlanCard = ({ title, price, periodicity, setPeriodicity, features, handlePurchase, isPopular, faturamento }) => {
  return (
    <div className={`flex flex-col gap-2 bg-white shadow-xl rounded-2xl h-fit plan-card overflow-hidden ${isPopular ? 'border-2 border-blue-500' : ''}`}>
      <div className={`flex justify-center ${isPopular ? 'bg-blue-500' : 'bg-[#27E2E7]'}`}>
        <h1 className='font-extrabold text-2xl p-4 text-white'>{title}</h1>
      </div>
      {isPopular && (
        <div className='bg-blue-500 text-white text-center py-1 text-sm font-medium'>
          MAIS VENDIDO
        </div>
      )}
      <div className='p-6'>
        <div className='flex justify-center items-baseline mb-4'>
          <span className='text-2xl font-semibold'>R$</span>
          <span className='text-6xl font-bold mx-1'>{price}</span>
          <span className='text-2xl font-semibold'>,00</span>
        </div>
        
        <div className='flex flex-col gap-4 items-center mb-6'>
          <Select
            value={periodicity}
            variant='outlined'
            onChange={(e) => setPeriodicity(e.target.value)}
            className='w-full max-w-xs'
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#27E2E7',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1fa8ac',
              },
            }}
          >
            <MenuItem value='MONTHLY'>Mensal</MenuItem>
            <MenuItem value='SEMIANNUALLY'>Semestral</MenuItem>
            <MenuItem value='YEARLY'>Anual</MenuItem>
          </Select>
          <span className='text-sm text-gray-600 font-medium'>
            {periodicity === 'SEMIANNUALLY' 
              ? '1 cobrança a cada 6 meses' 
              : periodicity === 'YEARLY' 
                ? '1 cobrança a cada 12 meses' 
                : '1 cobrança por mês'}
          </span>
          {(periodicity === 'SEMIANNUALLY' || periodicity === 'YEARLY') && (
            <span className='text-green-600 font-semibold'>
              {`Economize ${periodicity === 'SEMIANNUALLY' ? '1' : '2'} mensalidade${periodicity === 'YEARLY' ? 's' : ''}`}
            </span>
          )}
        </div>

        <div className='space-y-3'>
          {features.map((feature, index) => (
            <div key={index} className='flex items-start gap-3 py-2'>
              {feature.isGift ? (
                <CardGiftcard className='text-blue-500 flex-shrink-0' />
              ) : (
                <CheckCircleOutline className='text-green-500 flex-shrink-0' />
              )}
              <span className='text-gray-700'>{feature.text}</span>
            </div>
          ))}
        </div>

        <div className='mt-8 space-y-4'>
          <Button
            variant='contained'
            color={isPopular ? 'primary' : 'success'}
            onClick={handlePurchase}
            fullWidth
            sx={{
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 'bold',
              borderRadius: '8px',
              backgroundColor: isPopular ? '#3b82f6' : '#27E2E7',
              '&:hover': {
                backgroundColor: isPopular ? '#2563eb' : '#1fa8ac',
              },
            }}
          >
            Contratar
          </Button>
          <p className='text-sm text-gray-600 text-center font-medium'>
            {faturamento}
          </p>
        </div>
      </div>
    </div>
  );
};

const ProcessStep = ({ number, title, description }) => {
  return (
    <div className='process-step group relative flex flex-col items-center gap-6 p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2'>
      <div className='w-20 h-20 rounded-full flex items-center justify-center bg-gradient-to-br from-[#27E2E7] to-[#1fa8ac] group-hover:scale-110 transition-all duration-500'>
        <p className='text-3xl font-extrabold text-white'>{number}</p>
      </div>
      <div className='flex flex-col gap-3 text-center'>
        <h1 className='text-xl font-bold text-gray-800 group-hover:text-[#27E2E7] transition-colors duration-300'>
          {title}
        </h1>
        <p className='text-gray-600 leading-relaxed'>
          {description}
        </p>
      </div>
      <div className='absolute -z-10 inset-0 bg-gradient-to-br from-[#27E2E7]/20 to-transparent opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity duration-500'></div>
    </div>
  );
};

const BenefitCard = ({ icon: Icon, title, description }) => {
  return (
    <div className='benefit-card flex flex-col items-center gap-4 text-center p-8 bg-white rounded-xl shadow-lg transform transition-all duration-300 hover:shadow-2xl hover:-translate-y-1'>
      <div className='benefit-icon p-4 rounded-full bg-[#27E2E7]/10'>
        <Icon fontSize='large' sx={{ color: '#27E2E7' }} />
      </div>
      <h1 className='font-bold text-2xl text-gray-800'>{title}</h1>
      <p className='text-gray-600 leading-relaxed'>{description}</p>
    </div>
  );
};

const NavLink = ({ to, children }) => (
  <Link
    to={to}
    smooth={true}
    duration={500}
    offset={-20}
    className='text-gray-800 font-medium hover:text-[#27E2E7] transition-colors duration-300 cursor-pointer nav-link'
  >
    {children}
  </Link>
);

const BenefitListItem = ({ text, delay, index }) => (
  <div 
    className='flex items-center gap-4 group benefit-item glass-card p-4 rounded-xl'
    style={{
      animation: `fadeInUp 0.6s ease-out forwards`,
      animationDelay: `${delay}ms`,
      opacity: 0,
      transform: 'perspective(1000px)',
      transition: 'transform 0.3s ease'
    }}
  >
    <div className='rounded-full p-3 bg-gradient-to-br from-[#27E2E7]/30 to-[#27E2E7]/10 group-hover:from-[#27E2E7]/40 group-hover:to-[#27E2E7]/20 transition-all duration-500'>
      <CheckCircleOutline 
        className='text-[#27E2E7] transform group-hover:scale-110 transition-transform duration-300'
        sx={{ fontSize: index % 2 === 0 ? '1.4rem' : '1.5rem' }}
      />
    </div>
    <p className='font-medium text-lg group-hover:text-[#27E2E7] transition-colors duration-300 tracking-wide'>
      {text}
    </p>
  </div>
);

const ImpactMetric = ({ number, label }) => (
  <div className='flex flex-col items-center justify-center p-6 bg-white/10 backdrop-blur-sm rounded-2xl transform hover:scale-105 transition-all duration-500'>
    <span className='text-5xl md:text-7xl font-extrabold text-white mb-2 bg-gradient-to-r from-white to-white/80 bg-clip-text'>
      {number}
    </span>
    <span className='text-lg md:text-xl text-white/90 font-medium text-center'>
      {label}
    </span>
  </div>
);

const TestimonialCard = ({ videoId, title, author, role }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className='bg-white/10 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden transform hover:scale-[1.02] transition-all duration-500 hover:shadow-2xl border border-white/10'>
      <div className='relative w-full pb-[56.25%] bg-gradient-to-br from-[#27E2E7]/20 to-transparent'>
        {isLoading && (
          <div className='absolute inset-0 flex items-center justify-center'>
            <div className='w-12 h-12 border-4 border-[#27E2E7] border-t-transparent rounded-full animate-spin'></div>
          </div>
        )}
        <iframe
          className='absolute top-0 left-0 w-full h-full'
          src={`https://www.youtube.com/embed/${videoId}`}
          title={title}
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          allowFullScreen
          onLoad={() => setIsLoading(false)}
        ></iframe>
      </div>
      <div className='p-6 text-white'>
        <h3 className='text-xl font-bold mb-2 text-[#27E2E7]'>{title}</h3>
        <p className='text-lg font-medium text-white/90'>{author}</p>
        <p className='text-white/70'>{role}</p>
      </div>
    </div>
  );
};

const LandingPage = () => {
  const [selectedText, setSelectedText] = useState('o crescimento');
  const [periodicity1, setPeriodicity1] = useState('MONTHLY');
  const [periodicity2, setPeriodicity2] = useState('MONTHLY');
  const [periodicity3, setPeriodicity3] = useState('MONTHLY');
  const [menuDrawerOpen, setMenuDrawerOpen] = useState(false);

  const planosRef = useRef(null);

  const scrollToPlanos = () => {
    scroller.scrollTo('myScrollToElement', {
      duration: 500,
      smooth: true,
      offset: -80,
    });
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePurchase = (plan) => () => {
    if (plan === 'LIBERAL') {
      dispatch(newCustomerActions.setSelectedPlan('LIBERAL'));
      dispatch(newCustomerActions.setPeriodicity(periodicity1));
      if (periodicity1 === 'MONTHLY') {
        dispatch(newCustomerActions.setPrice(67));
      }
      if (periodicity1 === 'SEMIANNUALLY') {
        dispatch(newCustomerActions.setPrice(335));
      }
      if (periodicity1 === 'YEARLY') {
        dispatch(newCustomerActions.setPrice(670));
      }
    }
    if (plan === 'AVANÇADO') {
      dispatch(newCustomerActions.setSelectedPlan('AVANÇADO'));
      dispatch(newCustomerActions.setPeriodicity(periodicity2));
      if (periodicity2 === 'MONTHLY') {
        dispatch(newCustomerActions.setPrice(97));
      }
      if (periodicity2 === 'SEMIANNUALLY') {
        dispatch(newCustomerActions.setPrice(435));
      }
      if (periodicity2 === 'YEARLY') {
        dispatch(newCustomerActions.setPrice(970));
      }
    }
    if (plan === 'EMPRESARIAL') {
      dispatch(newCustomerActions.setSelectedPlan('EMPRESARIAL'));
      dispatch(newCustomerActions.setPeriodicity(periodicity3));
      if (periodicity3 === 'MONTHLY') {
        dispatch(newCustomerActions.setPrice(147));
      }
      if (periodicity3 === 'SEMIANNUALLY') {
        dispatch(newCustomerActions.setPrice(735));
      }
      if (periodicity3 === 'YEARLY') {
        dispatch(newCustomerActions.setPrice(1470));
      }
    }
    navigate('/finalizar-cadastro');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedText((prevText) => {
        const currentIndex = textArray.indexOf(prevText);
        const nextIndex = (currentIndex + 1) % textArray.length;
        return textArray[nextIndex];
      });
    }, 1500);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const planFeatures = {
    liberal: [
      { text: 'Modelagem financeira personalizada' },
      { text: 'Plano de contas a pagar e receber' },
      { text: 'Fluxo de caixa' },
      { text: 'Lançamentos' },
      { text: 'DRE e DFC preenchidas automaticamente' },
      { text: 'Atendimento vitalício', isGift: true },
      { text: 'Implantação com um de nossos consultores', isGift: true },
    ],
    avancado: [
      { text: 'Modelagem financeira personalizada' },
      { text: 'Plano de contas a pagar e receber' },
      { text: 'Fluxo de caixa' },
      { text: 'Lançamentos' },
      { text: 'DRE e DFC preenchidas automaticamente' },
      { text: 'Gráficos' },
      { text: 'Análise com dashboard interativo' },
      { text: 'Atendimento vitalício', isGift: true },
      { text: 'Implantação com um de nossos consultores', isGift: true },
    ],
    empresarial: [
      { text: 'Modelagem financeira personalizada' },
      { text: 'Plano de contas a pagar e receber' },
      { text: 'Fluxo de caixa' },
      { text: 'Lançamentos' },
      { text: 'DRE e DFC preenchidas automaticamente' },
      { text: 'Gráficos e calendário preenchidos automaticamente' },
      { text: 'Análise com dashboard interativo' },
      { text: 'Ferramenta de conciliação bancária' },
      { text: 'Atendimento vitalício', isGift: true },
      { text: 'Implantação com um de nossos consultores', isGift: true },
    ],
  };

  const processSteps = [
    {
      number: '1',
      title: 'Modelagem financeira',
      description: 'Processo realizado junto com um de nossos consultores de forma totalmente personalizada para o modelo da sua empresa.'
    },
    {
      number: '2',
      title: 'Registro e apresentação da plataforma',
      description: 'Criação da conta no VITA e análise dos grupos de contas. Apresentação da interface e das ferramentas e suas funcionalidades.'
    },
    {
      number: '3',
      title: 'Onboarding da plataforma',
      description: 'Apresentação das metodologias de controle financeiro que o VITA te fornece, através dos lançamentos, de maneira automática.'
    },
    {
      number: '4',
      title: 'Leitura das informações',
      description: 'Aprendizado com os nossos consultores para a leitura e entendimento dos números reais do seu negócio, com geração de um plano de ação e tomadas de decisão.'
    }
  ];

  const benefits = [
    {
      icon: CloudCircleOutlined,
      title: 'Sistema em Nuvem',
      description: 'Acesse seus dados financeiros de qualquer lugar, com total segurança e sincronização em tempo real.'
    },
    {
      icon: SmartphoneOutlined,
      title: 'App Móvel',
      description: 'Gerencie suas finanças na palma da mão com nosso app intuitivo para iOS e Android.'
    },
    {
      icon: ComputerOutlined,
      title: 'Análise Profissional',
      description: 'Dashboard completo com métricas, gráficos e relatórios para decisões estratégicas.'
    },
    {
      icon: CalendarMonth,
      title: 'Personalizado',
      description: 'Sistema adaptado ao seu modelo de negócio, com categorias e relatórios customizados.'
    }
  ];

  return (
    <div className='w-full'>
      <nav>
        <AppBar position='fixed' elevation={0} sx={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(8px)' }}>
          <Toolbar className='flex justify-between gap-2 h-20 px-4 md:px-8'>
            <div className='flex items-center'>
              <img src={logo} alt='vita-logo' className='w-16 h-auto transform hover:scale-105 transition-transform duration-300' />
            </div>
            <div className='flex lg:hidden'>
              <HamburgerComponent setIsShown={() => setMenuDrawerOpen(true)} />
            </div>
            <div className='hidden lg:flex lg:justify-end lg:gap-12 lg:flex-1'>
              <NavLink to='benefits'>Benefícios</NavLink>
              <NavLink to='testimonials'>Depoimentos</NavLink>
              <NavLink to='howItWorks'>Como funciona</NavLink>
              <NavLink to='plans'>Planos</NavLink>
              <RouterLink
                to='/privacidade'
                className='text-gray-800 font-medium hover:text-[#27E2E7] transition-colors duration-300 cursor-pointer nav-link'
              >
                Privacidade
              </RouterLink>
            </div>
          </Toolbar>
        </AppBar>

        <Drawer
          anchor='right'
          open={menuDrawerOpen}
          onClose={() => setMenuDrawerOpen(false)}
        >
          <div className='flex flex-col gap-6 p-8 w-64'>
            <Link
              to='benefits'
              smooth={true}
              duration={500}
              offset={-20}
              className='text-black font-semibold border-white border-b-2 hover:border-[#27E2E7] cursor-pointer duration-500'
              onClick={() => setMenuDrawerOpen(false)}
            >
              Benefícios
            </Link>
            <Link
              to='testimonials'
              smooth={true}
              duration={500}
              offset={-20}
              className='text-black font-semibold border-white border-b-2 hover:border-[#27E2E7] cursor-pointer duration-500'
              onClick={() => setMenuDrawerOpen(false)}
            >
              Depoimentos
            </Link>
            <Link
              to='howItWorks'
              smooth={true}
              duration={500}
              offset={-20}
              className='text-black font-semibold border-white border-b-2 hover:border-[#27E2E7] cursor-pointer duration-500'
              onClick={() => setMenuDrawerOpen(false)}
            >
              Como funciona
            </Link>
            <Link
              to='plans'
              smooth={true}
              duration={500}
              offset={30}
              className='text-black font-semibold border-white border-b-2 hover:border-[#27E2E7] cursor-pointer duration-500'
              onClick={() => setMenuDrawerOpen(false)}
            >
              Planos
            </Link>
            <RouterLink
              to='/privacidade'
              className='text-black font-semibold border-white border-b-2 hover:border-[#27E2E7] cursor-pointer duration-500'
            >
              Privacidade
            </RouterLink>
          </div>
        </Drawer>
      </nav>

      {/* Hero Section */}
      <div className='relative flex flex-col items-center justify-center min-h-screen bg-[url("./assets/vita-bg2.png")] bg-cover bg-center bg-fixed'>
        <div className='absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/60'></div>
        <div className='relative w-11/12 md:w-4/5 lg:w-3/5 flex flex-col items-center justify-center pt-32 pb-20 gap-12 text-white hero-content'>
          <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-center font-extrabold leading-tight tracking-tight'>
            A solução definitiva para a sua
            <span className='bg-gradient-to-r from-[#27E2E7] via-[#53BCC3] to-blue-400 text-transparent bg-clip-text gradient-animate'> organização e controle financeiro</span>
          </h1>
          
          <div className='flex flex-col items-start justify-start w-full bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm p-10 rounded-2xl border border-white/10 shadow-2xl transform hover:scale-[1.01] transition-all duration-700 glass-card'>
            <div className='w-full flex flex-col gap-10'>
              <p className='font-bold text-2xl lg:text-3xl text-transparent bg-clip-text bg-gradient-to-r from-[#27E2E7] to-[#53BCC3] gradient-animate pl-2'>
                Com o Vita, você:
              </p>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                {[
                  'Faz organização financeira',
                  'tem uma planilha de controle financeiro inteligente',
                  'diminui a sua ansiedade',
                  'aumenta a clareza para tomar decisões',
                  'ganha tempo',
                  'tem mais segurança'
                ].map((text, index) => (
                  <BenefitListItem 
                    key={index}
                    text={text}
                    delay={150 + index * 100}
                    index={index}
                  />
                ))}
              </div>
            </div>
          </div>

          <Button 
            variant='contained' 
            onClick={scrollToPlanos}
            size='large'
            className='group glass-card'
            sx={{
              background: 'linear-gradient(135deg, #27E2E7 0%, #53BCC3 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #1fa8ac 0%, #3a8a8f 100%)',
                transform: 'translateY(-2px)',
              },
              padding: '16px 40px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              borderRadius: '12px',
              boxShadow: '0 4px 14px 0 rgba(39, 226, 231, 0.39)',
              transition: 'all 0.3s ease',
            }}
          >
            Quero saber mais
            <span className='ml-2 group-hover:translate-x-1 transition-transform duration-300'>→</span>
          </Button>
        </div>
      </div>

      {/* Value Proposition Section */}
      <div className='relative overflow-hidden'>
        <div className='absolute inset-0 bg-gradient-to-r from-[#27E2E7] to-[#1fa8ac]'></div>
        <div className='relative flex items-center justify-center text-center w-full py-16 px-4'>
          <h1 className='text-xl lg:text-2xl font-bold text-white max-w-4xl'>
            <span className='font-extrabold text-2xl lg:text-3xl block mb-4 tracking-tight'>
              Acabe com sua INSEGURANÇA!
            </span>
            <span className='leading-relaxed'>
              Organização, Crescimento, Sucesso, e Resultado são características que o VITA proporciona para você empreendedor!
            </span>
          </h1>
        </div>
      </div>

      {/* Video Section */}
      <div className='relative overflow-hidden py-24'>
        <div className='absolute inset-0 bg-gradient-to-b from-gray-900 to-[#34536A]'></div>
        <div className='relative flex flex-col items-center justify-center text-center w-full gap-16 px-6'>
          <div className='flex flex-col items-center gap-6 max-w-4xl'>
            <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-[#27E2E7] via-[#53BCC3] to-blue-400 text-transparent bg-clip-text'>
              Conheça o Vita
            </h1>
            <p className='text-white/80 text-lg md:text-xl max-w-2xl'>
              Descubra como nossa plataforma pode revolucionar a gestão financeira do seu negócio através de nossos vídeos explicativos
            </p>
          </div>

          <div className='grid grid-cols-1 lg:grid-cols-3 gap-12 max-w-7xl w-full'>
            {[
              {
                title: 'Entenda as contas a pagar e a receber',
                description: 'Aprenda a gerenciar seu fluxo financeiro de forma eficiente e organizada',
                videoId: 'oAdQZpjbR9M'
              },
              {
                title: 'Lançamentos simples e rápidos',
                description: 'Economize tempo com nosso sistema intuitivo de lançamentos',
                videoId: 'jkZD9yySyxo'
              },
              {
                title: 'Descubra os pontos fortes e fracos do negócio',
                description: 'Analise seus dados e tome decisões estratégicas baseadas em informações reais',
                videoId: 'yNKgYB8n-Jw'
              }
            ].map((video, index) => (
              <div 
                key={index} 
                className='group relative flex flex-col gap-6 transform hover:translate-y-[-8px] transition-all duration-500'
              >
                <div className='relative w-full overflow-hidden rounded-2xl shadow-2xl'>
                  <div className='relative pb-[56.25%] bg-gradient-to-br from-[#27E2E7]/20 to-transparent'>
                    <iframe
                      className='absolute top-0 left-0 w-full h-full transform group-hover:scale-[1.02] transition-transform duration-500'
                      src={`https://www.youtube.com/embed/${video.videoId}`}
                      title={video.title}
                      frameBorder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                      referrerPolicy='strict-origin-when-cross-origin'
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
                <div className='flex flex-col gap-3 text-left p-4'>
                  <h2 className='text-[#27E2E7] text-xl md:text-2xl font-bold group-hover:text-[#53BCC3] transition-colors duration-300'>
                    {video.title}
                  </h2>
                  <p className='text-white/70 text-base md:text-lg leading-relaxed'>
                    {video.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className='relative flex flex-col gap-16 py-20 bg-gradient-to-br from-[#34536A] to-[#1d2f3d]' id='benefits'>
        <div className='absolute inset-0 bg-[url("./assets/vita-bg2.png")] bg-cover bg-center opacity-5'></div>
        <div className='relative text-center max-w-4xl mx-auto px-4'>
          <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-[#27E2E7] via-[#53BCC3] to-blue-400 text-transparent bg-clip-text gradient-animate'>
            Benefícios do Vita
          </h1>
          <p className='text-white/90 text-lg md:text-xl max-w-2xl mx-auto'>
            Descubra como o Vita pode transformar a gestão financeira do seu negócio
          </p>
        </div>
        
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-8 max-w-7xl mx-auto'>
          {benefits.map((benefit, index) => (
            <div key={index} 
              className='group flex flex-col items-center gap-6 p-8 bg-white/10 backdrop-blur-sm rounded-2xl border border-white/10 transform hover:scale-[1.02] transition-all duration-500 hover:shadow-2xl'
              style={{
                animation: `fadeInUp 0.6s ease-out forwards`,
                animationDelay: `${150 + index * 100}ms`,
                opacity: 0,
              }}
            >
              <div className='p-4 rounded-full bg-gradient-to-br from-[#27E2E7]/30 to-[#27E2E7]/10 group-hover:from-[#27E2E7]/40 group-hover:to-[#27E2E7]/20 transition-all duration-500'>
                <benefit.icon 
                  className='text-[#27E2E7] transform group-hover:scale-110 transition-transform duration-300'
                  sx={{ fontSize: '2.5rem' }}
                />
              </div>
              <div className='flex flex-col gap-3 text-center'>
                <h3 className='text-xl font-bold text-[#27E2E7] group-hover:text-[#53BCC3] transition-colors duration-300'>
                  {benefit.title}
                </h3>
                <p className='text-white/80 leading-relaxed'>
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials Section */}
      <div className='relative flex flex-col items-center justify-center gap-12 py-20 bg-gradient-to-br from-[#34536A] to-[#1d2f3d]' id='testimonials'>
        <div className='absolute inset-0 bg-[url("./assets/vita-bg2.png")] bg-cover bg-center opacity-5'></div>
        <div className='relative text-center max-w-4xl px-4'>
          <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-[#27E2E7] via-[#53BCC3] to-blue-400 text-transparent bg-clip-text gradient-animate'>
            O que nossos clientes dizem
          </h1>
          <p className='text-white/90 text-lg md:text-xl max-w-2xl mx-auto'>
            Descubra como o Vita tem transformado a gestão financeira de diversos negócios
          </p>
        </div>
        
        <div className='relative w-full max-w-7xl px-4'>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
            <TestimonialCard
              videoId="2vgPmd8HnVk"
              title="A organização que precisávamos"
              author="Geleias Âmbar"
              role="Empresa de Alimentos"
            />
            <TestimonialCard
              videoId="NTy7qNhj_BI"
              title="Transformação na gestão financeira"
              author="Urutu Barbearia"
              role="Serviços de Beleza"
            />
            <TestimonialCard
              videoId="ZhJb0lSQFgc"
              title="Controle financeiro simplificado"
              author="Salgaderia Maria"
              role="Empresa de Alimentos"
            />
            <TestimonialCard
              videoId="eL6X37snmlQ"
              title="Resultados que fazem diferença"
              author="Tenda do EVA"
              role="Comércio Varejista"
            />
          </div>
        </div>
      </div>

      {/* Clients Section */}
      <div className='relative flex flex-col items-center justify-center gap-12 py-20 overflow-hidden' style={{ backgroundColor: '#34536A' }}>
        <div className='absolute inset-0 bg-[url("./assets/vita-bg2.png")] bg-cover bg-center opacity-5'></div>
        <div className='relative grid grid-cols-1 gap-8 max-w-5xl mx-auto px-4'>
          <ImpactMetric number="+400" label="Empreendedores impactados" />
        </div>
        <div className='relative w-full max-w-7xl px-4'>
          <h2 className='text-2xl md:text-3xl font-bold text-white text-center mb-8'>
            Empresas que confiam no Vita
          </h2>
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={3000}
            removeArrowOnDeviceType={["tablet", "mobile"]}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
            containerClass="carousel-container pb-12"
          >
            {[
              { src: empresa1, alt: 'Empresa 1' },
              { src: empresa2, alt: 'Empresa 2' },
              { src: empresa3, alt: 'Empresa 3' },
              { src: empresa4, alt: 'Empresa 4' },
              { src: empresa5, alt: 'Empresa 5' },
              { src: empresa6, alt: 'Empresa 6' },
              { src: empresa7, alt: 'Empresa 7' },
              { src: empresa8, alt: 'Empresa 8' },
              { src: empresa9, alt: 'Empresa 9' },
              { src: empresa10, alt: 'Empresa 10' },
              { src: empresa11, alt: 'Empresa 11' },
              { src: empresa12, alt: 'Empresa 12' },
              { src: empresa13, alt: 'Empresa 13' }
            ].map((company, index) => (
              <div key={index} className='flex items-center justify-center p-4'>
                <div className='bg-white rounded-xl p-4 hover:shadow-lg transition-all duration-300'>
                  <img
                    src={company.src}
                    alt={company.alt}
                    className='object-contain w-32 h-32'
                    onError={(e) => {
                      e.target.onerror = null;
                      console.log(`Failed to load image: ${company.alt}`);
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      {/* Process Section */}
      <div className='flex flex-col items-center justify-center gap-16 py-20 bg-gradient-to-b from-gray-50 to-white' id='howItWorks'>
        <div className='max-w-4xl px-4 text-center'>
          <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 bg-gradient-to-r from-[#27E2E7] to-[#1fa8ac] text-transparent bg-clip-text'>
            Como funciona
          </h1>
          <div className='relative inline-block'>
            <p className='text-xl md:text-2xl font-bold mb-8 text-gray-800'>
              4 passos simples para
              <span className='relative ml-3 text-[#27E2E7] transition-all duration-500'>
                {selectedText}
                <span className='absolute bottom-0 left-0 w-full h-0.5 bg-[#27E2E7] transform scale-x-0 transition-transform duration-500 group-hover:scale-x-100'></span>
              </span>
            </p>
          </div>
          <p className='text-gray-600 max-w-2xl mx-auto text-lg'>
            Nossa metodologia comprovada garante uma transição suave e eficiente para o controle financeiro do seu negócio
          </p>
        </div>
        
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-8 max-w-7xl mx-auto'>
          {processSteps.map((step, index) => (
            <ProcessStep
              key={index}
              number={step.number}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>

        <Button 
          variant='contained'
          onClick={scrollToPlanos}
          size='large'
          className='group'
          sx={{
            background: 'linear-gradient(135deg, #27E2E7 0%, #53BCC3 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #1fa8ac 0%, #3a8a8f 100%)',
              transform: 'translateY(-2px)',
            },
            padding: '16px 40px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            borderRadius: '12px',
            boxShadow: '0 4px 14px 0 rgba(39, 226, 231, 0.39)',
            transition: 'all 0.3s ease',
          }}
        >
          Começar agora
          <span className='ml-2 group-hover:translate-x-1 transition-transform duration-300'>→</span>
        </Button>
      </div>

      {/* Plans Section */}
      <div className='flex flex-col items-center justify-center gap-16 py-20 bg-gray-50' id='plans' ref={planosRef}>
        <Element name='myScrollToElement'>
          <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-4' style={{ color: '#27E2E7' }}>
            Planos
          </h1>
          <p className='text-xl text-gray-600 text-center'>Escolha o plano ideal para o seu negócio</p>
        </Element>
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-8 px-4 max-w-7xl mx-auto'>
          <PlanCard
            title="Liberal"
            price={periodicity1 === 'MONTHLY' ? '67' : periodicity1 === 'SEMIANNUALLY' ? '335' : '670'}
            periodicity={periodicity1}
            setPeriodicity={setPeriodicity1}
            features={planFeatures.liberal}
            handlePurchase={handlePurchase('LIBERAL')}
            faturamento="Para faturamentos até R$6.000,00"
          />
          <PlanCard
            title="Avançado"
            price={periodicity2 === 'MONTHLY' ? '97' : periodicity2 === 'SEMIANNUALLY' ? '435' : '970'}
            periodicity={periodicity2}
            setPeriodicity={setPeriodicity2}
            features={planFeatures.avancado}
            handlePurchase={handlePurchase('AVANÇADO')}
            isPopular={true}
            faturamento="Para faturamentos entre R$6.000,00 e R$15.000,00"
          />
          <PlanCard
            title="Empresarial"
            price={periodicity3 === 'MONTHLY' ? '147' : periodicity3 === 'SEMIANNUALLY' ? '735' : '1.470'}
            periodicity={periodicity3}
            setPeriodicity={setPeriodicity3}
            features={planFeatures.empresarial}
            handlePurchase={handlePurchase('EMPRESARIAL')}
            faturamento="Para faturamentos superiores a R$15.000,00"
          />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
